import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { Select, OptionList, Trigger, Option, utils } from 'selectly/lib/Selectly';
import { difference, uniq } from 'lodash';
import styled from '@emotion/styled';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import { mainColors } from 'src/assets/colors';

export const ChevronDownWrapper = styled(ChevronDownIcon)`
    fill: ${mainColors.main.primary};
    margin: 13px 8px;
    position: absolute;
    pointer-events: none;
    right: 5px;
    top: 0;
`;


class CheckboxMultiSelect extends React.Component {
  static defaultProps = {
    hasCheckbox: true
  };

  constructor(props) {
    super(props)
    this.state = {
      label: props.label,
      value: props.value && props.value !== 'null' ? props.value : [],
      list: props.list || {}
    }
  }

  UNSAFE_componentWillMount() {
    this._handleChange = this._handleChange.bind(this)
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.list !== this.state.list) {
      this.setState({
        list: props.list
      });
    }

    if (props.value !== this.state.value) {
      this.setState({
        value: props.value || []
      });
    }
  }

  onFocus() {
    this.setState({
      focus: true
    });

    this.props.onFocus();
  }

  onBlur() {
    this.setState({
      focus: false
    });

    this.props.onBlur();
  }

  _renderOption(key, label) {
    const hasCheckbox = this.props.hasCheckbox;
    const isSelected = utils.isOptionSelected(this.state.value, key);

    return (
      <Option key={key} value={key}>
        {({ props }) =>
          <div
            {...props}
            className={
              'react-select-option' +
              (hasCheckbox ? ' has-checkbox' : '') +
              (isSelected ? ' is-selected' : '')
            }
            data-test={'select-option-' + props.id}
          >
            {hasCheckbox &&
              <input
                type="checkbox"
                className="react-select-option__checkbox"
                checked={isSelected}
                readOnly
              />}
            {label}
          </div>}
      </Option>
    )
  }

  _handleChange(target, stop, e) {
    if (stop === 'stop') {
      e.stopPropagation();
    }

    let value = utils.getToggledValues(this.state.value, target.value);
    this.setState({
      value: value
    });

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  onToggle(target) {
    const { value } = this.state;

    if (target && !target.getModifierState() && value !== this.props.value) {
      // work if is closed menu
      this.props.onCloseMenu ? this.props.onCloseMenu(target, value, this.props.name) : {};
    }
  }

  render() {
    const { list } = this.state;
    const { placeholder, onCloseMenu = () => { } } = this.props;

    let value = this.state.value && this.state.value !== 'null' ? this.state.value : [];

    const arrayTopSelectedId = Object.keys(list);
    let updatedList = difference(arrayTopSelectedId, value);
    let sortedSelected = value.sort(function (a, b) {
      return arrayTopSelectedId.indexOf(a) > arrayTopSelectedId.indexOf(b) ? 1 : -1;
    });

    const labelCountries = value.map(key => list[key]).join(', ');

    return (

      <Select
        classPrefix="react-select"
        multiple
        onChange={this._handleChange}
      >
        <Trigger className="react-select-trigger" onTrigger={this.onToggle.bind(this)} data-test="select-trigger">
          {value.length > 0
            ? labelCountries.length < 50 ? labelCountries : labelCountries.substr(0, 50) + '...'
            : placeholder
          }
          <ChevronDownWrapper />
        </Trigger>
        <OptionList
          closeOnOutsideClick={true}
          onOptionSelection={this._handleChange}
          onRequestClose={(e) => { onCloseMenu(e, this.state.value, this.props.name) }}
          className="react-select-menu react-select-options"
          tag="ul"
        >
          {
            sortedSelected.concat(updatedList).map(key => this._renderOption(key, list[key]))
          }
        </OptionList>
      </Select>
    )
  }
}

export default CheckboxMultiSelect;
